import { useState, useEffect } from "react";
import { IoCloseSharp } from "react-icons/io5";
import logo from "../../Assets/logo.png";
import { useTranslation } from "react-i18next";
import iconBtn from "../../Assets/icon_btn.png";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { TiThMenu } from "react-icons/ti";
import LanguageSwitcher from "../LanguageSwitcher";
import styles from "./menuMobile.module.css";

export const MenuMobile = () => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  // bloquear scroll do body enquanto o menu mobile estiver aberto
  useEffect(() => {
    const originalBodyOverflow = document.body.style.overflow;
    const originalHtmlOverflow = document.documentElement.style.overflow;

    if (open) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
    }

    return () => {
      document.body.style.overflow = originalBodyOverflow;
      document.documentElement.style.overflow = originalHtmlOverflow;
    };
  }, [open]);

  const scrollToSection = (id) => {
    // Fechar o menu primeiro para restaurar o scroll da página, depois rolar
    // até a seção. Se tentarmos scrollIntoView enquanto o body estiver
    // overflow: hidden, o scroll pode não ocorrer.
    const section = document.getElementById(id);

    setOpen(false);

    // dar um pequeno delay para garantir que o overflow foi restaurado
    // após o fechamento do menu antes de tentar o scroll.
    if (section) {
      window.setTimeout(() => {
        section.scrollIntoView({ behavior: "smooth" });
      }, 50);
    }
  };

  return (
    <div className={styles.wrapper}>
      <img src={logo} alt={t("menu.alt")} />

      <div className={styles.rightBox}>
        <a
        href="https://store.steampowered.com/app/3234720/Lugh_World/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <button className={styles.wishBtn}>
          <img src={iconBtn} alt="" />
          {t("buttons.wishlist")}
          <MdOutlineKeyboardArrowRight />
        </button>
      </a>
        <button onClick={() => setOpen(!open)}>
          <TiThMenu size={24} />
        </button>
      </div>

      {open && (
        <div className={styles.modal}>
          <div className={styles.menuBox}>
            <div className={styles.headerNav}>
              <img src={logo} alt={t("menu.alt")} />
              <button onClick={() => setOpen(!open)}>
                <IoCloseSharp size={24} />
              </button>
            </div>

            <button
              className={styles.btnMenu}
              onClick={() => scrollToSection("home")}
            >
              {t("menu.home")}
            </button>

            <button
              className={styles.btnMenu}
              onClick={() => scrollToSection("about")}
            >
              {t("menu.about")}
            </button>

            <button
              className={styles.btnMenu}
              onClick={() => scrollToSection("lughs")}
            >
              {t("menu.lughs")}
            </button>

            <button
              className={styles.btnMenu}
              onClick={() => scrollToSection("gallery")}
            >
              {t("menu.gallery")}
            </button>

            <button
              className={styles.btnMenu}
              onClick={() => scrollToSection("video")}
            >
              {t("menu.video")}
            </button>

            <button
              className={styles.btnMenu}
              onClick={() => scrollToSection("faq")}
            >
              {t("menu.faq")}
            </button>

            <LanguageSwitcher />
          </div>
        </div>
      )}
    </div>
  );
};
